/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useContext, useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import FormInput from "../../../components/FormInput";
import { validationRules } from "../../../utils/validationRules";
import {
  createCarLoan,
  getCarLoanByEmail,
  getCarLoanByMobile,
  getAllCities,
  getAllPincode,
  getAllStates,
} from "../../../middleware/backend_hepler";
import { AuthContext } from "../../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Row, Col, Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SelectInput from "../../../components/SelectInput";
import DropDownInput from "../../../components/DropDownInput";

const CreateCarForm = () => {
  const { adminId, adminName } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [states, setStates] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [pincodenumber, setPincode] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);

  const methods = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const {
    handleSubmit,
    watch,
    trigger,
    formState: { errors, isValid },
  } = methods;
  const [mobileExists, setMobileExists] = useState(false);
  const [emailExists, setEmailExists] = useState(false);
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const steps = ["Personal Details", "Loan Details", "Upload Documents"];

  const handleStepChange = async (newStep) => {
    if (newStep > activeStep) {
      const isValid = await trigger();
      if (isValid) {
        if (emailExists) {
          toast.error("Email already exists. Please use a different email.");
          return;
        }

        if (mobileExists) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
          return;
        }

        setActiveStep(newStep);
      }
    } else {
      setActiveStep(newStep);
    }
  };

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const statesData = await getAllStates();
        const availableStates = statesData.filter(
          (state) => state.availability === "Yes"
        );
        setStates(availableStates);
        setFilteredStates(availableStates);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching states data:", error);
        setLoading(false);
      }
    };
    fetchStates();
  }, []);

  const stateOptions = filteredStates.map((state) => ({
    value: state.name,
    label: state.name,
  }));

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const citiesData = await getAllCities();
        citiesData.sort((a, b) => a.name.localeCompare(b.name));
        const tamilNaduCities = citiesData.filter(
          (city) => city.State_name === "Tamil Nadu"
        );

        const options = tamilNaduCities.map((city) => ({
          value: city.name,
          label: city.name,
        }));
        setCities(tamilNaduCities);
        setCityOptions(options);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchCities();
  }, []);

  useEffect(() => {
    const fetchPinCode = async () => {
      try {
        const pincodeData = await getAllPincode();

        const tamilNaduStates = pincodeData.filter(
          (pincode) => pincode.state === "TAMIL NADU"
        );

        const uniquePincodes = new Set();
        const uniqueOptions = [];

        tamilNaduStates.forEach((pincode) => {
          if (!uniquePincodes.has(pincode.pincode)) {
            uniquePincodes.add(pincode.pincode);
            uniqueOptions.push({
              value: pincode.pincode,
              label: pincode.pincode,
            });
          }
        });
        uniqueOptions.sort((a, b) => a.value - b.value);
        setPincode(tamilNaduStates);
        setPincodeOptions(uniqueOptions);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchPinCode();
  }, []);

  const checkMobile = async (mobile) => {
    if (mobile) {
      try {
        const data = await getCarLoanByMobile(mobile);
        setMobileExists(Boolean(data));
      } catch (error) {
        setMobileExists(false);
      }
    }
  };

  const checkEmail = async (email) => {
    if (email) {
      try {
        const data = await getCarLoanByEmail(email);
        setEmailExists(Boolean(data));
      } catch (error) {
        setEmailExists(false);
      }
    }
  };

  const handleFileChange = (event) => {
    console.log(event.target.files);
  };

  const onSubmit = (data) => {
    data.created_by = adminName;
    data.created_id = adminId;

    data.status = data.status || "open";
    data.assigned_to = data.assigned_to || "";

    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (
        key === "pan_card" ||
        key === "aadhar_card" ||
        key === "photo" ||
        key === "gst" ||
        key === "signature" ||
        key === "cosigner_signature"
      ) {
        formData.append(key, data[key][0]);
      } else {
        formData.append(key, data[key]);
      }
    });

    createCarLoan(formData)
      .then((response) => {
        console.log("Car loan application submitted:", response);
        navigate("/carloanlist", {
          state: { successMessage: "Car loan created successfully!" },
        });
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.message;
  
        if (typeof errorMessage === "string") {
          if (errorMessage.includes("Email already exists")) {
            toast.error("Email already exists. Please use a different email.");
          } else if (errorMessage.includes("Mobile number already exists")) {
            toast.error("Mobile number already exists. Please use a different mobile number.");
          } else {
            console.error("Error submitting loan application:", errorMessage);
            toast.error("Failed to submit loan application. Please try again.");
          }
        } else {
          console.error("Error submitting loan application:", error);
          toast.error("Failed to submit loan application. Please try again.");
        }
      });
  };

  const email = watch("email");
  const mobile = watch("mobile");

  React.useEffect(() => {
    if (email) {
      checkEmail(email);
    }
  }, [email]);

  React.useEffect(() => {
    if (mobile) {
      checkMobile(mobile);
    }
  }, [mobile]);

  return (
    <div className="container">
      {activeStep === 0 && (
        <div className="edit-back-icon">
            <div 
                className="edit-back-text"
                onClick={() => navigate("/carloanlist")}>
                &lt; Go Back 
            </div>
        </div>
    )}
      <h2 className="my-4">Car Loan</h2>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className="form-group">
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            className="stepper-container"
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div className="form-content">
            {activeStep === 0 && (
              <div className="sections personal-details-sections">
                <h4>Personal Details</h4>
                <div className="form-row">
                  <FormInput
                    name="name"
                    label="Name"
                    registerOptions={validationRules.name}
                    error={errors.name?.message}
                  />
                  <FormInput
                    name="dob"
                    label="Date of Birth"
                    type="date"
                    registerOptions={{
                      required: "Date of Birth is required",
                      validate: {
                        isOldEnough: (value) => {
                          const today = new Date();
                          const minAgeDate = new Date();
                          minAgeDate.setFullYear(today.getFullYear() - 21);
                          return (
                            new Date(value) <= minAgeDate ||
                            "You must be at least 21 years old"
                          );
                        },
                        isNotFutureDate: (value) => {
                          return (
                            new Date(value) <= new Date() ||
                            "Date of Birth cannot be in the future"
                          );
                        },
                      },
                    }}
                    error={errors.dob?.message}
                  />
                </div>
                <div className="form-row">
                  <DropDownInput
                    name="maritalstatus"
                    label="Marital Status"
                    options={[
                      { value: "single", label: "Single" },
                      { value: "married", label: "Married" },
                      { value: "separated", label: "Separated" },
                      { value: "divorced", label: "Divorced" },
                      { value: "widowed", label: "Widowed" },
                    ]}
                    registerOptions={{ required: "Status is required" }}
                    error={errors.maritalstatus?.message}
                  />
                  <FormInput
                    name="email"
                    label="Email"
                    //type="email"
                    registerOptions={validationRules.email}
                    error={errors.email?.message}
                  />
                </div>
                <div className="form-row">
                  <FormInput
                    name="mobile"
                    label="Mobile"
                    type="tel"
                    registerOptions={validationRules.mobile}
                    error={
                      mobileExists
                        ? "Mobile number already exists"
                        : errors.mobile?.message
                    }
                  />
                  <FormInput
                    name="current_address"
                    label="Address"
                    registerOptions={{ required: "Address is required" }}
                    error={errors.current_address?.message}
                  />
                </div>
                <div className="form-row">
                  <SelectInput
                    name="state"
                    label="State"
                    options={stateOptions}
                    registerOptions={{ required: "State is required" }}
                    error={errors.state?.message}
                  />
                  <SelectInput
                    name="city"
                    label="City"
                    options={cityOptions}
                    error={errors.city?.message}
                    registerOptions={{ required: "City is required" }}
                  />
                </div>
                <div className="form-row">
                  <SelectInput
                    name="pincode"
                    label="Pincode"
                    options={pincodeOptions}
                    registerOptions={{ required: "Pincode is required" }}
                    rules={{ required: "Pincode is required" }}
                  />
                  <FormInput
                    name="emergency_contact_phone"
                    label="Emergency Contact Phone"
                    type="tel"
                    registerOptions={validationRules.mobile}
                    error={errors.emergency_contact_phone?.message}
                  />

                </div>

              </div>
            )}
            {activeStep === 1 && (
              <div className="sections requested-loan-details-sections">
                <h4> Loan Details</h4>
                <div className="form-row">
                  <DropDownInput
                    name="loan_type"
                    label="Loan Type"
                    options={[
                      { value: "Used Car", label: "Used Car" },
                      { value: "New Car", label: "New Car" },
                    ]}
                    registerOptions={{ required: "Loan Type is required" }}
                    error={errors.loan_type?.message}
                  />
                    <DropDownInput
                    name="employee_type"
                    label="Employee Type"
                    options={[
                      { value: "salaried", label: "Salaried" },
                      { value: "self employed", label: "Self Employed" },
                    ]}
                    registerOptions={{ required: "Employee Type is required" }}
                  />
                  </div>
                  <div className="form-row">
                  <FormInput
                    name="requested_loan_amount"
                    label="Loan Amount"
                    type="number"
                    registerOptions={{ required: "Loan Amount is required" }}
                    error={errors.requested_loan_amount?.message}
                  />
                    <FormInput
                    name="monthly_income"
                    label="Monthly Net Income"
                    type="number"
                    registerOptions={{
                      required: "Monthly Net Income is required",
                    }}
                    error={errors.monthly_income?.message}
                  />
                  </div>

                <div className="sections financial-details-sections">
                  <div className="form-row">
                    <FormInput
                      name="current_bank_name"
                      label="Current Bank Name"
                      registerOptions={{
                        required: "Current Bank Name is required",
                      }}
                      error={errors.current_bank_name?.message}
                    />
                    <FormInput
                      name="branch"
                      label="Branch"
                      registerOptions={{ required: "Branch is required" }}
                      error={errors.branch?.message}
                    />
                  </div>
                  <div className="form-row">
                    <DropDownInput
                      name="account_type"
                      label="Account Type"
                      options={[
                        { value: "savings", label: "Savings" },
                        { value: "current", label: "Current" },
                      ]}
                      registerOptions={{ required: "Account Type is required" }}
                      error={errors.account_type?.message}
                    />
                    <FormInput
                      name="account_number"
                      label="Account Number"
                      type="number"
                      registerOptions={{
                        required: "Account Number is required",
                      }}
                      error={errors.account_number?.message}
                    />
                  </div>
                  <div className="form-row">
                    <DropDownInput
                      name="own_house"
                      label="Do you own or rent your home?"
                      options={[
                        { value: "own", label: "Own" },
                        { value: "rent", label: "Rent" },
                      ]}
                      registerOptions={{
                        required: "Home Ownership status is required",
                      }}
                      error={errors.own_house?.message}
                    />
                    <DropDownInput
                      name="current_loan"
                      label="Do you have any current loan?"
                      options={[
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                      ]}
                      registerOptions={{
                        required: "Current Loan status is required",
                      }}
                      error={errors.current_loan?.message}
                    />
                  </div>

                </div>
                <h4>Vehicle Details</h4>
                <div className="form-row">
                  <FormInput
                    name="make_model"
                    label="Make & Model"
                    registerOptions={{ required: "Make & Model is required" }}
                    error={errors.make_model?.message}
                  />
                  <FormInput
                    name="registered_year"
                    label="Registered Year"
                    type="number"
                    registerOptions={{
                      required: "Registered Year is required",
                    }}
                    error={errors.registered_year?.message}
                  />
                </div>
                <div className="form-row">
                  <FormInput
                    name="registration_number"
                    label="Registration Number"
                    registerOptions={{
                      required: "Registration Number is required",
                    }}
                    error={errors.registration_number?.message}
                  />
                </div>
              </div>
            )}
            {activeStep === 2 && (
              <div className="sections financial-details-sections">
                <div className="form-row">
                  <div className="sections document-upload-sections">
                    <div className="document-upload-group">
                      <div className="document-label-container">
                        <label htmlFor="pan_card" className="document-label">
                          PAN Card
                        </label>
                      </div>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="pan_card"
                          className="form-control-file"
                          {...methods.register("pan_card")}
                          onChange={handleFileChange}
                        />
                        {/* <div className="file-name">{fileNames.pan_card}</div> */}
                      </div>
                    </div>
                    <div className="document-upload-group">
                      <div className="document-label-container">
                        <label htmlFor="aadhar_card" className="document-label">
                          Aadhaar Card
                        </label>
                      </div>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="aadhar_card"
                          className="form-control-file"
                          {...methods.register("aadhar_card")}
                          onChange={handleFileChange}
                        />
                        {/* <div className="file-name">{fileNames.aadhar_card}</div> */}
                      </div>
                    </div>
                    <div className="document-upload-group">
                      <div className="document-label-container">
                        <label htmlFor="photo" className="document-label">
                          Photo
                        </label>
                      </div>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="photo"
                          className="form-control-file"
                          {...methods.register("photo")}
                          onChange={handleFileChange}
                        />
                        {/* <div className="file-name">{fileNames.photo}</div> */}
                      </div>
                    </div>
                    <div className="document-upload-group">
                      <div className="document-label-container">
                        <label htmlFor="signature" className="document-label">
                          Signature
                        </label>
                      </div>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="signature"
                          className="form-control-file"
                          {...methods.register("signature")}
                          onChange={handleFileChange}
                        />
                      </div>
                    </div>
                    <div className="document-upload-group">
                      <div className="document-label-container">
                        <label
                          htmlFor="coSignerSignature"
                          className="document-label"
                        >
                          Co-signer's Signature
                        </label>
                      </div>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="cosigner_signature"
                          className="form-control-file"
                          {...methods.register("cosigner_signature")}
                          onChange={handleFileChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="button-container">
            <Row className="mt-4">
              <Col className="text-end">
                {activeStep > 0 && (
                  <Button
                    variant="secondary"
                    onClick={() => handleStepChange(activeStep - 1)}
                    className="custom-back-button"
                  >
                    Go Back
                  </Button>
                )}
                {activeStep < steps.length - 1 && (
                  <Button
                    variant="primary"
                    onClick={() => handleStepChange(activeStep + 1)}
                    className="custom-next-button"
                  >
                    Next Step
                  </Button>
                )}
                {activeStep === steps.length - 1 && (
                  <Button
                    type="submit"
                    variant="primary"
                    className="custom-submit-button"
                  >
                    Submit
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </form>
      </FormProvider>
      <ToastContainer />
    </div>
  );
};

export default CreateCarForm;
